require('./modifyDebitLimitsStep1.scss');

const PropTypes = require('prop-types');

//@vendor
const React = require('react');
//@components
const ModifyDebitLimitsInformativeSection = require('components/cards/cardModifyDebitLimits/modifyDebitLimitsInformativeSection/modifyDebitLimitsInformativeSection');
const ModifyDebitLimitsSliderSection = require('components/cards/cardModifyDebitLimits/modifyDebitLimitsSliderSection/modifyDebitLimitsSliderSection');
//@constants
const { FIRST_STEP } = require('constants/index');

class ModifyDebitLimitsStep1 extends React.Component {
    render() {
        const {
            immCard,
            immCardModifyDebitLimits,
            handleLimitChange,
        } = this.props;

        const immStepOne = immCardModifyDebitLimits.getIn(['steps', FIRST_STEP]);
        const immLimits = immCardModifyDebitLimits.getIn(['debitLimits', immCardModifyDebitLimits.get('operationType'), 'limits']);

        return (
            <article className="modify-debit-limits-step-one">
                <ModifyDebitLimitsInformativeSection
                    immCard={immCard}
                    immCardModifyDebitLimits={immCardModifyDebitLimits}
                    titleKey="modifyDebitLimitsInformativeSection-stepOneTitle"
                />
                <ModifyDebitLimitsSliderSection
                    immCard={immCard}
                    immLimits={immLimits}
                    limitAlertVisible={immStepOne.get('limitIsDirty') && !immStepOne.get('limitIsValid')}
                    handleLimitChange={handleLimitChange}
                    limit={immStepOne.get('limit')}
                    operationType={immCardModifyDebitLimits.get('operationType')}
                />
            </article>
        );
    }
}

ModifyDebitLimitsStep1.propTypes = {
    immCard: PropTypes.object,
    immCardModifyDebitLimits: PropTypes.object,
    handleLimitChange: PropTypes.func,
};

module.exports = ModifyDebitLimitsStep1;
